import { render, staticRenderFns } from "./StatementImport.vue?vue&type=template&id=01a0b6c7"
import script from "./StatementImport.vue?vue&type=script&lang=js"
export * from "./StatementImport.vue?vue&type=script&lang=js"
import style0 from "./StatementImport.vue?vue&type=style&index=0&id=01a0b6c7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports